export default __webpack_public_path__ + "static/media/location--13.8f7e85cb.jpg";